/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Html_HintInputs */

const cs_builder_html_hint = /** @type {(inputs: Builder_Html_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pište na stránce. Vložte tokeny polí pro CRM data. Náhled zkompiluje PDF pro kontrolu.`)
};

const en_builder_html_hint = /** @type {(inputs: Builder_Html_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write on the page. Insert field tokens for CRM data. Preview compiles a PDF to check the result.`)
};

/**
* | output |
* | --- |
* | "Write on the page. Insert field tokens for CRM data. Preview compiles a PDF to check the result." |
*
* @param {Builder_Html_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_html_hint = /** @type {((inputs?: Builder_Html_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Html_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_html_hint(inputs)
	return cs_builder_html_hint(inputs)
});